import axiosIns from "@/api/axios";

export const getListApprovalDeputyCOO = async (params) => {
    const { token, page = 1, limit = 10 } = params;
    try {
        const response = await axiosIns.get('/common/idp/deputy-coo/submitted-learnings', {
            params: {
                token,
                page,
                limit,
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching approval Deputy COO:', error);
        throw error;
    }
}

export const approveIDPByDeputyCOO = async (params) => {
    const { token, ids = [] } = params;
    try {
        const response = await axiosIns.post('/common/idp/deputy-coo/approve', {
            ids,
        }, {
            params: {
                token,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error approving IDP by Deputy COO:', error);
        throw error;
    }
}

export const rejectIDPByDeputyCOO = async (params) => {
    const { token, ids = [], reason = '' } = params;
    try {
        const response = await axiosIns.post('/common/idp/deputy-coo/reject', {
            ids,
            reason,
        }, {
            params: {
                token,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error rejecting IDP by Deputy COO:', error);
        throw error;
    }
}
